import { combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromSearchForm from './search-form';
import {
  getAgencyInvolvementValue,
  getImPermanentAcceptanceValue,
  getInvolvedTrafficAgencyLightsValue,
  getSelectedDossierStatusesValue,
  getSelectedMyProgressStatusesValue,
  getSelectedProcessTypeValue,
  getSelectedTrainTypeValue,
  getTransitionValue
} from './search-form';
import * as fromSearchOptions from './search-options';

export interface AdvancedSearchState {
  searchForm: fromSearchForm.State;
  searchOptions: fromSearchOptions.State;
}

export interface State {
  advancedSearchState: AdvancedSearchState;
}

const getAdvancedSearchState = createFeatureSelector<AdvancedSearchState>('advancedSearchState');

const getDossierSearchCriteriaState = createSelector(
  getAdvancedSearchState,
  (state: AdvancedSearchState) => state.searchForm
);

const getAdvancedSearch = createSelector(
  getAdvancedSearchState,
  (state: AdvancedSearchState) => state.searchOptions
);

export const getAdvancedSearchForm = createSelector(
  getDossierSearchCriteriaState,
  (state: fromSearchForm.State) => state.advancedSearchForm
);

export const getAdditionalFields = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.additionalFields
);

export const getLabelsForUser = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.labelsForUser
);

export const getTransitions = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.transitions
);

export const getProcessTypes = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.processTypes
);

export const getDossierStatuses = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.dossierStatuses
);

export const getFilter = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.filter
);

export const getSearchType = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.searchType
);

export const getHasOperationInProgress = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.hasOperationInProgress
);

export const getSearchedPermanentAcceptance = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.searchedPermanentAcceptance
);

export const getSelectedTransition = createSelector(
  getAdvancedSearchForm,
  getTransitionValue
);

export const getSelectedProcessType = createSelector(
  getAdvancedSearchForm,
  getSelectedProcessTypeValue
);

export const getSelectedDossierStatuses = createSelector(
  getAdvancedSearchForm,
  getSelectedDossierStatusesValue
);

export const getMyProgressStatuses = createSelector(
  getAdvancedSearchForm,
  getSelectedMyProgressStatusesValue
);

export const getAgencyInvolvement = createSelector(
  getAdvancedSearchForm,
  getAgencyInvolvementValue
);

export const getImPermanentAcceptance = createSelector(
  getAdvancedSearchForm,
  getImPermanentAcceptanceValue
);

export const getInvolvedAgencyTrafficLightPairs = createSelector(
  getAdvancedSearchForm,
  getInvolvedTrafficAgencyLightsValue
);

export const getAgencyInvolvementOptions = createSelector(
  getAdvancedSearch,
  (state: fromSearchOptions.State) => state.agencyInvolvementOptions
);

export const getSelectedTrainType = createSelector(
  getAdvancedSearchForm,
  getSelectedTrainTypeValue
);

function dossierSearchCriteriaReducer(state, action) {
  return fromSearchForm.reducer(state, action);
}

function advancedSearchReducer(state, action) {
  return fromSearchOptions.reducer(state, action);
}

export const reducers = combineReducers({
  searchForm: dossierSearchCriteriaReducer,
  searchOptions: advancedSearchReducer
});

export function reducerForAdvanceSearch(state, action) {
  return reducers(state, action);
}
